// extracted by mini-css-extract-plugin
module.exports = {"container":"e_sk","imageCont":"e_tk","image":"e_uk","title":"e_vk","description":"e_wk","socials":"e_xk","socialLink":"e_yk","socialIcon":"e_zk"};